import { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useOrderApi, { Order } from "../../api/OrderApi";

interface Props {
  formId: number;
}

const FormActiveOrders = (props: Props) => {
  const orderApi = useOrderApi();
  const [activeOrders, setActiveOrders] = useState<Order[]>();
  const isFormUsedInAnyOrder = activeOrders === undefined || activeOrders.length === 0;

  useEffect(() => {
    orderApi.fetchFormActiveOrders(props.formId)
      .then(setActiveOrders);
  }, [props.formId]);

  return <>
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      { isFormUsedInAnyOrder
        ? <div>Formatka nie jest wykorzystana bezpośrednio w żadnym aktywnym zamówieniu</div>
        : <div>Aktywne zamówienia</div>
      }
      </AccordionSummary>
      <AccordionDetails>
      { activeOrders === undefined
        ? <div>...</div>
        : activeOrders.length === 0
          ? <div>Formatka nie jest wykorzystana bezpośrednio w żadnym aktywnym zamówieniu</div>
          : <ul> { activeOrders.map(order => (<li>Zamówienie: {order.number}</li>)) }</ul>
      }
      </AccordionDetails>
    </Accordion>
    </>;
}

export default FormActiveOrders;